var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#3E7BFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1281 6.63643C11.4746 6.19519 10.6978 5.97322 9.90973 6.00258C9.30092 5.98373 8.69986 6.144 8.18116 6.4636C7.43214 6.94376 7.03834 7.7408 7 8.85484H8.72857V8.85474C8.73119 8.51676 8.83126 8.18665 9.01666 7.90408C9.12395 7.74671 9.27127 7.62105 9.44355 7.53993C9.61582 7.4589 9.80667 7.42542 9.99621 7.44305C10.4571 7.44305 10.774 7.56787 10.947 7.81762C11.1215 8.0607 11.2125 8.35386 11.2062 8.65312C11.2083 8.91169 11.1275 9.16403 10.9758 9.37336C10.8798 9.50643 10.7631 9.62309 10.63 9.71902L10.1979 10.0647V10.0648C9.85894 10.2907 9.58162 10.5976 9.39124 10.9579C9.25498 11.406 9.18699 11.8722 9.18952 12.3407H10.8029C10.8008 12.1074 10.8298 11.8749 10.8893 11.6493C10.959 11.3879 11.1104 11.1557 11.3214 10.9866L11.7536 10.6698C12.0764 10.4406 12.3671 10.1693 12.6179 9.86304C12.8779 9.48201 13.0092 9.02764 12.9924 8.56662C13.0548 7.8175 12.7284 7.08881 12.1282 6.63643L12.1281 6.63643Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16064 13.1185H10.9468V14.8326H9.16064V13.1185Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/supportIcon.201154e348f60660a957b1fe2991727b.svg";
export { ForwardRef as ReactComponent };